import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useTenant from "../../../hooks/useTenant";
import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import FilterReset from "../../../components/FilterReset";
import { searchPayload, convertedValue } from "../../../utils/common";
import { OperatorConstants } from "../../../constants/operator.constants";
import ReactHookFormSelect from "../../../components/ReactHookFormSelect";
import CustomTextField from "../../../components/CustomTextField";
import { useDialog } from "../../../contexts/DialogContext";
import useAgreementTracker from "../../../hooks/useAgreementTracker";
import CustomDatePicker from "../../../components/CustomDatePicker";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const initialValues = {
    tenantNameOperator: "eq",
    agreementNumberOperator: "eq",
    dateOfAgreementOperator: "btn",
    tenantName: [],
    agreementNumber: [],
    dateOfAgreement: [],
    dateOfAgreementStr: "",
  };

  const { fields, payload, setPayload, setFilterResetFunc } = props;

  const { autoSearchTenant, tenantAutoSearchResults, isLoadingAutoSearch } = useTenant();

  const [tenantPayload, setTenantPayload] = useState(currentPayload);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [tenantMultiValue, setTenantMultiValue] = useState(false);

  const [defaultTenant, setDefaultTenant] = useState([]);

  const { autoSearchAgreementTracker, agreementTrackerAutoSearchResults } = useAgreementTracker();

  const [agreementNumberPayload, setAgreementNumberPayload] = useState(currentPayload);
  const [agreementNumberOptions, setAgreementNumberOptions] = useState([]);
  const [agreementNumberMultiValue, setAgreementNumberMultiValue] = useState(false);

  const [defaultAgreementNumber, setDefaultAgreementNumber] = useState([]);

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => reset);
  }, [reset]);

  const tenantOpValue = watch("tenantNameOperator");

  const agreementNumberOpValue = watch("agreementNumberOperator");

  const onSubmit = async (data) => {
    try {
      let filters = [];

      if (data.tenantName != null && Object.keys(data.tenantName).length != 0) {
        filters.push({
          fieldName: "tenantId",
          fieldValue: convertedValue(data.tenantName, "value").join(","),
          op: data.tenantNameOperator,
          dataType: "int",
          condition: "and",
          isJoin: true,
        });
      }
      if (data.agreementNumber != null && Object.keys(data.agreementNumber).length != 0) {
        filters.push({
          fieldName: "agreementTrackerId",
          fieldValue: convertedValue(data.agreementNumber, "value").join(","),
          op: data.agreementNumberOperator,
          dataType: "int",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.dateOfAgreement != "" && data.dateOfAgreement != null) {
        filters.push({
          fieldName: "dateOfAgreement",
          fieldValue: data.dateOfAgreementStr,
          op: data.dateOfAgreementOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }

      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.log(err, "errerrerrerr");
    }
  };

  useEffect(() => {
    if (tenantOpValue == "in" || tenantOpValue == "nin") {
      setDefaultTenant([]);
      setValue("tenantName", []);
      setTenantMultiValue(true);
    } else {
      setDefaultTenant({});
      setValue("tenantName", {});
      setTenantMultiValue(false);
    }
  }, [tenantOpValue]);

  useEffect(() => {
    if (agreementNumberOpValue == "in" || agreementNumberOpValue == "nin") {
      setDefaultAgreementNumber([]);
      setValue("agreementNumber", []);
      setAgreementNumberMultiValue(true);
    } else {
      setDefaultAgreementNumber({});
      setValue("agreementNumber", {});
      setAgreementNumberMultiValue(false);
    }
  }, [agreementNumberOpValue]);

  const fetchTenant = async () => {
    await autoSearchTenant(tenantPayload);
  };
  useEffect(() => {
    fetchTenant();
  }, [tenantPayload]);

  useEffect(() => {
    console.log(tenantAutoSearchResults, "tenantAutoSearchResults");
    if (tenantAutoSearchResults.data.length !== 0) {
      setTenantOptions([...tenantOptions, ...tenantAutoSearchResults.data]);
    }
  }, [tenantAutoSearchResults]);

  const fetchAgreementNumber = async () => {
    await autoSearchAgreementTracker(agreementNumberPayload);
  };
  useEffect(() => {
    fetchAgreementNumber();
  }, [agreementNumberPayload]);

  useEffect(() => {
    console.log(agreementTrackerAutoSearchResults, "agreementTrackerAutoSearchResults");
    if (agreementTrackerAutoSearchResults.data.length !== 0) {
      setAgreementNumberOptions([
        ...agreementNumberOptions,
        ...agreementTrackerAutoSearchResults.data,
      ]);
    }
  }, [agreementTrackerAutoSearchResults]);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} pt={8}>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="tenantNameOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <SearchableAutoComplete
                control={control}
                data={tenantOptions}
                label={t("franchise_name")}
                payload={tenantPayload}
                setPayload={setTenantPayload}
                loading={isLoadingAutoSearch}
                name="tenantName"
                multiple={tenantMultiValue}
                defaultValue={defaultTenant}
                hasNextPage={tenantAutoSearchResults.paging.hasNextPage}
              />
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="agreementNumberOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <SearchableAutoComplete
                control={control}
                data={agreementNumberOptions}
                label={t("agreement_number")}
                payload={agreementNumberPayload}
                setPayload={setAgreementNumberPayload}
                loading={isLoadingAutoSearch}
                name="agreementNumber"
                multiple={agreementNumberMultiValue}
                defaultValue={defaultAgreementNumber}
                hasNextPage={agreementTrackerAutoSearchResults.paging.hasNextPage}
              />
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="dateOfAgreementOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.date).map((t, k) => (
                  <MenuItem key={k} value={t[0]}>
                    {t[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item md={6}>
              <CustomDatePicker
                name="dateOfAgreement"
                nameTemp="dateOfAgreementStr"
                label={t("date_of_agreement")}
                range={true}
                control={control}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={reset} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
